export default "__VITE_ASSET__lxctVY8r__"